@file:OptIn(InternalResourceApi::class)

package kinoshazam.resources.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/kinoshazam.resources.generated.resources/"

public val Res.string.profile_theme_dark: StringResource by lazy {
      StringResource("string:profile_theme_dark", "profile_theme_dark", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 10818, 38),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6450, 54),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 15357, 54),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 10818, 38),
      ))
    }

public val Res.string.profile_theme_light: StringResource by lazy {
      StringResource("string:profile_theme_light", "profile_theme_light", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 10857, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6505, 55),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 15412, 55),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 10857, 43),
      ))
    }

public val Res.string.profile_title: StringResource by lazy {
      StringResource("string:profile_title", "profile_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 10931, 33),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6611, 41),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 15518, 41),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 10931, 33),
      ))
    }

public val Res.string.remaining_min: StringResource by lazy {
      StringResource("string:remaining_min", "remaining_min", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 10965, 41),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 15560, 61),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 10965, 41),
      ))
    }

public val Res.string.remove_from_continue: StringResource by lazy {
      StringResource("string:remove_from_continue", "remove_from_continue", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11007, 56),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 15622, 80),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11007, 56),
      ))
    }

public val Res.string.repeat: StringResource by lazy {
      StringResource("string:repeat", "repeat", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11233, 22),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6822, 38),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 15944, 38),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11233, 22),
      ))
    }

public val Res.string.repeat_password_error: StringResource by lazy {
      StringResource("string:repeat_password_error", "repeat_password_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11064, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6653, 53),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 15703, 77),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11064, 53),
      ))
    }

public val Res.string.repeat_password_hint: StringResource by lazy {
      StringResource("string:repeat_password_hint", "repeat_password_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11118, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6707, 60),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 15781, 84),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11118, 60),
      ))
    }

public val Res.string.repeat_password_label: StringResource by lazy {
      StringResource("string:repeat_password_label", "repeat_password_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11179, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6768, 53),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 15866, 77),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11179, 53),
      ))
    }

public val Res.string.review_videos: StringResource by lazy {
      StringResource("string:review_videos", "review_videos", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11256, 77),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6861, 77),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 15983, 117),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11256, 77),
      ))
    }

public val Res.string.search: StringResource by lazy {
      StringResource("string:search", "search", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11610, 26),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7331, 34),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16549, 34),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11610, 26),
      ))
    }

public val Res.string.search_actors: StringResource by lazy {
      StringResource("string:search_actors", "search_actors", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11334, 33),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6939, 33),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16101, 41),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11334, 33),
      ))
    }

public val Res.string.search_empty: StringResource by lazy {
      StringResource("string:search_empty", "search_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11368, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 6973, 104),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16143, 104),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11368, 40),
      ))
    }

public val Res.string.search_found: StringResource by lazy {
      StringResource("string:search_found", "search_found", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11409, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7078, 68),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16248, 68),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11409, 60),
      ))
    }

public val Res.string.search_hint: StringResource by lazy {
      StringResource("string:search_hint", "search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11470, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7147, 47),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16317, 75),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11470, 51),
      ))
    }

public val Res.string.search_result: StringResource by lazy {
      StringResource("string:search_result", "search_result", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11522, 45),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7195, 89),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16393, 89),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11522, 45),
      ))
    }

public val Res.string.search_videos: StringResource by lazy {
      StringResource("string:search_videos", "search_videos", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11568, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7285, 45),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16483, 65),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11568, 41),
      ))
    }

public val Res.string.season: StringResource by lazy {
      StringResource("string:season", "season", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11696, 30),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7366, 30),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16651, 34),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11696, 30),
      ))
    }

public val Res.string.season_episode: StringResource by lazy {
      StringResource("string:season_episode", "season_episode", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11637, 58),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16584, 66),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11637, 58),
      ))
    }

public val Res.string.share_app: StringResource by lazy {
      StringResource("string:share_app", "share_app", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11727, 29),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7397, 77),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16686, 77),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11727, 29),
      ))
    }

public val Res.string.short: StringResource by lazy {
      StringResource("string:short", "short", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11757, 29),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7475, 29),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16764, 53),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11757, 29),
      ))
    }

public val Res.string.soon_in_cinema: StringResource by lazy {
      StringResource("string:soon_in_cinema", "soon_in_cinema", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11787, 30),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7505, 54),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16818, 54),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11787, 30),
      ))
    }

public val Res.string.sport: StringResource by lazy {
      StringResource("string:sport", "sport", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11818, 21),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7560, 21),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16873, 29),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11818, 21),
      ))
    }

public val Res.string.telegram: StringResource by lazy {
      StringResource("string:telegram", "telegram", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11840, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7582, 56),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16903, 56),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11840, 40),
      ))
    }

public val Res.string.trailer: StringResource by lazy {
      StringResource("string:trailer", "trailer", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11881, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7639, 27),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16960, 35),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11881, 27),
      ))
    }

public val Res.string.triller: StringResource by lazy {
      StringResource("string:triller", "triller", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11909, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7667, 27),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 16996, 35),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11909, 27),
      ))
    }

public val Res.string.tv_show_cartoon: StringResource by lazy {
      StringResource("string:tv_show_cartoon", "tv_show_cartoon", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11937, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7695, 55),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17032, 55),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11937, 35),
      ))
    }

public val Res.string.tv_shows: StringResource by lazy {
      StringResource("string:tv_shows", "tv_shows", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12034, 28),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7812, 36),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17173, 36),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12034, 28),
      ))
    }

public val Res.string.tv_shows_watched: StringResource by lazy {
      StringResource("string:tv_shows_watched", "tv_shows_watched", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 11973, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7751, 60),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17088, 84),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 11973, 60),
      ))
    }

public val Res.string.update_ask: StringResource by lazy {
      StringResource("string:update_ask", "update_ask", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12063, 30),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7849, 42),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17210, 42),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12063, 30),
      ))
    }

public val Res.string.update_available: StringResource by lazy {
      StringResource("string:update_available", "update_available", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12094, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7892, 76),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17253, 76),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12094, 48),
      ))
    }

public val Res.string.update_download_failed: StringResource by lazy {
      StringResource("string:update_download_failed", "update_download_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12143, 82),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 7969, 170),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17330, 170),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12143, 82),
      ))
    }

public val Res.string.update_exit: StringResource by lazy {
      StringResource("string:update_exit", "update_exit", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12226, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 8140, 35),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17501, 35),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12226, 27),
      ))
    }

public val Res.string.update_no: StringResource by lazy {
      StringResource("string:update_no", "update_no", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12254, 25),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 8176, 33),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17537, 33),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12254, 25),
      ))
    }

public val Res.string.update_yes: StringResource by lazy {
      StringResource("string:update_yes", "update_yes", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12280, 26),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 8210, 42),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17571, 42),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12280, 26),
      ))
    }

public val Res.string.uzhas: StringResource by lazy {
      StringResource("string:uzhas", "uzhas", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12307, 21),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 8253, 21),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17614, 29),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12307, 21),
      ))
    }

public val Res.string.voenniy: StringResource by lazy {
      StringResource("string:voenniy", "voenniy", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12351, 19),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 8297, 19),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17682, 35),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12351, 19),
      ))
    }

public val Res.string.voenniy_2: StringResource by lazy {
      StringResource("string:voenniy_2", "voenniy_2", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12329, 21),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 8275, 21),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17644, 37),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12329, 21),
      ))
    }

public val Res.string.watch: StringResource by lazy {
      StringResource("string:watch", "watch", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12504, 21),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 8367, 37),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17947, 37),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12504, 21),
      ))
    }

public val Res.string.watch_again: StringResource by lazy {
      StringResource("string:watch_again", "watch_again", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12371, 35),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17718, 55),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12371, 35),
      ))
    }

public val Res.string.watch_all: StringResource by lazy {
      StringResource("string:watch_all", "watch_all", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12407, 21),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 8317, 49),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17774, 49),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12407, 21),
      ))
    }

public val Res.string.watch_history: StringResource by lazy {
      StringResource("string:watch_history", "watch_history", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12429, 41),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17824, 69),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12429, 41),
      ))
    }

public val Res.string.watched_mark: StringResource by lazy {
      StringResource("string:watched_mark", "watched_mark", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12471, 32),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17894, 52),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12471, 32),
      ))
    }

public val Res.string.welcome_fraze_1: StringResource by lazy {
      StringResource("string:welcome_fraze_1", "welcome_fraze_1", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12526, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 8405, 87),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 17985, 87),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12526, 55),
      ))
    }

public val Res.string.welcome_fraze_2: StringResource by lazy {
      StringResource("string:welcome_fraze_2", "welcome_fraze_2", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12582, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 8493, 91),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 18073, 91),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12582, 63),
      ))
    }

public val Res.string.welcome_fraze_3: StringResource by lazy {
      StringResource("string:welcome_fraze_3", "welcome_fraze_3", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12646, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 8585, 71),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 18165, 71),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12646, 47),
      ))
    }

public val Res.string.welcome_fraze_4: StringResource by lazy {
      StringResource("string:welcome_fraze_4", "welcome_fraze_4", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12694, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 8657, 95),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 18237, 95),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12694, 63),
      ))
    }

public val Res.string.welcome_fraze_5: StringResource by lazy {
      StringResource("string:welcome_fraze_5", "welcome_fraze_5", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12758, 71),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 8753, 79),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 18333, 79),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12758, 71),
      ))
    }

public val Res.string.western: StringResource by lazy {
      StringResource("string:western", "western", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12830, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 8833, 27),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 18413, 35),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12830, 27),
      ))
    }

public val Res.string.which_watch: StringResource by lazy {
      StringResource("string:which_watch", "which_watch", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/Strings.commonMain.cvr", 12858, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/Strings.commonMain.cvr", 8861, 59),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/Strings.commonMain.cvr", 18449, 59),
        ResourceItem(setOf(), "${MD}values/Strings.commonMain.cvr", 12858, 43),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("profile_theme_dark", Res.string.profile_theme_dark)
  map.put("profile_theme_light", Res.string.profile_theme_light)
  map.put("profile_title", Res.string.profile_title)
  map.put("remaining_min", Res.string.remaining_min)
  map.put("remove_from_continue", Res.string.remove_from_continue)
  map.put("repeat", Res.string.repeat)
  map.put("repeat_password_error", Res.string.repeat_password_error)
  map.put("repeat_password_hint", Res.string.repeat_password_hint)
  map.put("repeat_password_label", Res.string.repeat_password_label)
  map.put("review_videos", Res.string.review_videos)
  map.put("search", Res.string.search)
  map.put("search_actors", Res.string.search_actors)
  map.put("search_empty", Res.string.search_empty)
  map.put("search_found", Res.string.search_found)
  map.put("search_hint", Res.string.search_hint)
  map.put("search_result", Res.string.search_result)
  map.put("search_videos", Res.string.search_videos)
  map.put("season", Res.string.season)
  map.put("season_episode", Res.string.season_episode)
  map.put("share_app", Res.string.share_app)
  map.put("short", Res.string.short)
  map.put("soon_in_cinema", Res.string.soon_in_cinema)
  map.put("sport", Res.string.sport)
  map.put("telegram", Res.string.telegram)
  map.put("trailer", Res.string.trailer)
  map.put("triller", Res.string.triller)
  map.put("tv_show_cartoon", Res.string.tv_show_cartoon)
  map.put("tv_shows", Res.string.tv_shows)
  map.put("tv_shows_watched", Res.string.tv_shows_watched)
  map.put("update_ask", Res.string.update_ask)
  map.put("update_available", Res.string.update_available)
  map.put("update_download_failed", Res.string.update_download_failed)
  map.put("update_exit", Res.string.update_exit)
  map.put("update_no", Res.string.update_no)
  map.put("update_yes", Res.string.update_yes)
  map.put("uzhas", Res.string.uzhas)
  map.put("voenniy", Res.string.voenniy)
  map.put("voenniy_2", Res.string.voenniy_2)
  map.put("watch", Res.string.watch)
  map.put("watch_again", Res.string.watch_again)
  map.put("watch_all", Res.string.watch_all)
  map.put("watch_history", Res.string.watch_history)
  map.put("watched_mark", Res.string.watched_mark)
  map.put("welcome_fraze_1", Res.string.welcome_fraze_1)
  map.put("welcome_fraze_2", Res.string.welcome_fraze_2)
  map.put("welcome_fraze_3", Res.string.welcome_fraze_3)
  map.put("welcome_fraze_4", Res.string.welcome_fraze_4)
  map.put("welcome_fraze_5", Res.string.welcome_fraze_5)
  map.put("western", Res.string.western)
  map.put("which_watch", Res.string.which_watch)
}
